import { Button, Col } from "antd";
import { useSetNextPlayerMutation } from "../../../../utils/useSetNextPlayerMutation";
import { usePlayerSolvedMutation } from "../../../../utils/usePlayerSolvedMutation";
import { useSelector } from "../../../../../../redux/store";
import { activePlayerSelector } from "../../../../../../redux/selectors/activePlayerSelector";

export const GameMasterActionMenu = () => {
  const nextPlayerMutation = useSetNextPlayerMutation();
  const playerSolvedMutation = usePlayerSolvedMutation();
  const activePlayer = useSelector(activePlayerSelector)!;

  return (
    <>
      <Col span={12}>
        <Button
          block
          onClick={() => playerSolvedMutation.mutate(activePlayer.userId)}
          type={"dashed"}
        >
          Spieler hat es gelöst
        </Button>
      </Col>
      <Col span={12}>
        <Button
          block
          onClick={() => nextPlayerMutation.mutate()}
          type={"primary"}
        >
          Nächster Spieler
        </Button>
      </Col>
    </>
  );
};
